import React, { useState, useEffect, ChangeEvent } from 'react';
import { Row, Col, Alert } from 'react-bootstrap'
import Card from '../../../../components/Card'
import { DetailItem } from '../../../../features/details';
import { getDescriptions } from '../../../../services/api/site'
import { addLocation, updateLocation } from '../../../../services/api/location';
import { Location, ApiError } from '../../../../services/openapi';
import { useKeycloak } from '@react-keycloak/web'
import { Link, useNavigate } from "react-router-dom";
import { NotImplementedWarningModal } from '../../../../components/NotImplementedWarningModal';
import { useTranslation } from 'react-i18next'; 

const LocationDetails = () => {
    const [location, setLocation] = useState<any>();
    const [showInputEle, setShowInputEle] = useState<boolean>(false);
    const [showModal, setShowModal] = useState(false);
    const [errorMsg, setErrorMsg] = useState<string[]>([]);
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
    const [siteDescriptions, setSiteDescriptions] = useState<Record<string,string>>({});

    const { keycloak } = useKeycloak();
    const token = keycloak?.token || '';

    const navigate = useNavigate();
    const { t } = useTranslation();

    const navigateBack = () => navigate('/dashboard/lists/locations');

    const setLocationData = (data: Location) => {
        localStorage.setItem('Location', JSON.stringify(data));
    }

    const toggleInputElements = (show: boolean) => {
        setShowInputEle(show);
        if (show) {
            document.querySelector('.errorMsg')?.classList.add("d-none");
            errorMsg.length = 0;
        }
    }

    const pushErrorMessages = (errors: any) => {
        try {
            Object.entries<Record<string, any>>(errors).forEach((k) => { k[1].forEach((msg: string) => { errorMsg.push(msg); setErrorMsg(errorMsg); }) });
        } catch (ex) {
            errorMsg.push("Error handling response");
            setErrorMsg(errorMsg);
        }
    }

    useEffect(() => {
        if (location == null) {
                getDescriptions(token).then(map => {
                setSiteDescriptions(map);
            }).catch((ex: ApiError) => {
                console.log(ex);
                showErrorMessages(["Error handling response"]);
            });

            const json = localStorage.getItem('Location') ?? "";
            const item = JSON.parse(json);
            setLocation(item);

            if (item && item["id"] === 0) {
                toggleInputElements(true);
            }
        }
    }, [isRefreshing, location]);

    function handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault();

        document.querySelector('.errorMsg')?.classList.add("d-none");
        errorMsg.length = 0;

        if (e.currentTarget.checkValidity()) {
            setIsRefreshing(true);
            let l: Location = location;
            setLocationData(l);
            if (l.id === 0) {
                addLocation(token, l).then((id) => {
                    if (id) {
                        let nl: Location = { ...(l as Location)} as Location;
                        nl.id = id;
                        setLocation(nl);
                        setLocationData(nl);
                        setIsRefreshing(false);
                        navigateBack();
                    }
                }).catch((error: ApiError) => {
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        pushErrorMessages(JSON.parse((error as any).message || error.body)["errors"]);
                    } catch (ex) {
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }
            else {
                updateLocation(token, l.id ?? 0, l).then(() => navigateBack()).catch((error: ApiError) => {
                    try {
                        document.querySelector('.errorMsg')?.classList.remove("d-none");
                        pushErrorMessages(JSON.parse((error as any).body)["errors"]);
                    } catch (ex) {
                        showErrorMessages(["Error handling response"]);
                    }
                });
            }

            toggleInputElements(!showInputEle);
        }
    }

    const showErrorMessages = (msgs?: string[]) => {
        document.querySelector('.errorMsg')?.classList.remove("d-none");
        if (msgs && msgs.length > 0) {
            msgs.forEach(m => errorMsg.push(m));
            setErrorMsg([...errorMsg]);
        }
    }

    return (
        <>
            <div className="">
                <NotImplementedWarningModal
                    showModal={showModal}
                    handleClose={() => setShowModal(false)}
                />
            </div>
            <Row className="">
                <Col className="">
                    <Card className="rounded">
                        <Card.Body className="">
                            <form onSubmit={e => handleSubmit(e)}>
                                <Row className="d-none d-md-block"><Col>&nbsp;</Col></Row>
                                <Row className="d-none d-md-block"><Col>&nbsp;</Col></Row>
                                <Row className=""><Col sm="12"><h4 className="mb-2 qvend-title">{location?.id ? t('details') : t('lokatieToevoegen')}</h4></Col></Row>
                                <Row className="">
                                    <Col sm="12" xs="12" className="mt-2">
                                        <div className="table-responsive-lg" style={{ overflowX: 'hidden' }}>
                                            <div>
                                                {location && location["propertyNames"] && Object.entries(location as any).filter(([key, value]) => location["propertyNames"]?.[key] !== undefined && (location["propertyNames"][key].editType !== '' || (location["propertyNames"][key].editType === '' && value !== null))).sort((a, b) => location["propertyNames"][a[0]].sortOrderLevel - location["propertyNames"][b[0]].sortOrderLevel).map(([key, value], index) => (
                                                    <DetailItem key={location["propertyNames"][key].sortOrderLevel} propertyName={location["propertyNames"][key].name} defaultValue={value ?? ""} rowColor={index % 2 ? "#cfd5ea" : "#e9ebf5"} editType={location["propertyNames"][key].editType} pattern={location["propertyNames"][key].valPattern} hideOnNull={location["propertyNames"][key].hideOnNull}
                                                        handleDoubleClick={() => setShowInputEle(true)}
                                                        handleChange={(e: ChangeEvent<HTMLInputElement>) => { location[key] = (e.target.value); setLocation(location); }} showInputEle={showInputEle} possibilities={location["propertyNames"][key].predefinedValues} possibilityDescriptions={ siteDescriptions } conditionToShowReferenceValue={location[location["propertyNames"][key].conditionToShowFieldName]} conditionToShowValue={location["propertyNames"][key].conditionToShowValue}></DetailItem>
                                                ))}                                                
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="d-none errorMsg"><Col>{errorMsg.map((item, index) => (<Alert key={index} variant="warning" className="alert" role="alert"><span>{item}</span></Alert>))}</Col></Row>

                                <Row style={{ paddingTop: "12px" }}><Col></Col><Col className="text-end"></Col></Row>

                                <Row style={{ paddingTop: "3px" }}>
                                    <Col>
                                        <Link to="/dashboard/lists/locations" onClick={() => { }}>
                                            <button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px', backgroundColor: "red" }} onClick={() => { }}>{showInputEle ? t("button.cancel") : t("button.back")}</button>
                                        </Link>
                                    </Col>
                                    <Col className="text-end">
                                        {showInputEle ? (<button type="submit" className="btn btn-fixed-width" style={{ fontSize: '11px' }}>{location && location?.id > 0 ? t('button.save') : t('button.add')}</button>) : (<button type="button" className="btn btn-fixed-width" style={{ fontSize: '11px' }} onClick={(e) => { e.preventDefault(); setShowInputEle(true); }}>{t('button.edit')}</button>)}
                                    </Col>
                                </Row>

                            </form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default LocationDetails;
